export const mutation_cerved_searchEntitiesAdvanced = `
mutation cervedSearchEntitiesAdvanced($tenantId: String!, $aziendaId: Int!, $criteria: CervedAdvancedSearchCriteria!) {
    cervedSearchEntitiesAdvanced(tenantId: $tenantId, aziendaId: $aziendaId, criteria: $criteria) {
        items {
            idSoggetto
            denominazione
            nome
            cognome
            codiceFiscale
            partitaIva
            naturaGiuridica
            statoAttivita
            isPerson
            indirizzo
            comune
            provincia
        }
        totalCount
        truncated
    }
}`;
